(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.landing-faqs .faq-item');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Cerrar todos
        items.forEach((i) => i.classList.remove('is-open'));

        // Si NO estaba abierto, lo abrimos
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-feature-items-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.landing-feature-items-carousel .item');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((i) => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');

        // 👇 forzar recálculo de slick (posición + altura)
        $carousel.slick('setPosition');
        $carousel.slick('refresh');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-feature-items"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('featureModal');
    if (!modal) return;

    /* ======================
     MODAL ELEMENTS
  ====================== */

    const overlay = modal.querySelector('.fm-overlay');

    const itemBox = modal.querySelector('.fm-item');
    const videoBox = modal.querySelector('.fm-video');

    const img = modal.querySelector('.fm-img');
    const title = modal.querySelector('.fm-title');
    const text = modal.querySelector('.fm-text');
    const description = modal.querySelector('.fm-description');

    /* Modal Video */
    const modalVideo = modal.querySelector('.fm-video-el');
    const modalPlayBtn = modal.querySelector('#modalPlayBtn');

    /* Mobile Video */
    const mobilePlayBtn = document.getElementById('playVideoMobile');
    const mobileVideo = document.querySelector('.video-mobile video');

    /* ======================
     MOBILE VIDEO CONTROL
  ====================== */

    if (mobilePlayBtn && mobileVideo) {
      mobilePlayBtn.addEventListener('click', () => {
        mobileVideo.play();
      });

      mobileVideo.addEventListener('play', () => {
        mobilePlayBtn.style.display = 'none';
      });

      mobileVideo.addEventListener('pause', () => {
        mobilePlayBtn.style.display = 'flex';
      });

      mobileVideo.addEventListener('ended', () => {
        mobilePlayBtn.style.display = 'flex';
      });

      mobileVideo.addEventListener('click', () => {
        mobileVideo.play();
        mobilePlayBtn.style.display = 'none';
      });
    }

    /* ======================
     OPEN ITEM MODAL
  ====================== */

    document.querySelectorAll('.landing-feature-items .item').forEach((item) => {
      item.addEventListener('click', () => {
        img.src = item.dataset.image;
        title.textContent = item.dataset.title;
        text.textContent = item.dataset.text;

        const hiddenDescription = item.querySelector('.item-description');
        description.innerHTML = hiddenDescription ? hiddenDescription.innerHTML : '';

        itemBox.style.display = 'block';
        videoBox.style.display = 'none';

        openModal();
      });
    });

    /* ======================
     OPEN VIDEO MODAL
  ====================== */

    const videoBtn = document.querySelector('.open-video-modal');

    if (videoBtn) {
      videoBtn.addEventListener('click', () => {
        const temp = document.createElement('div');
        temp.innerHTML = videoBtn.dataset.video;

        const newVideo = temp.querySelector('video');

        if (newVideo && modalVideo) {
          modalVideo.innerHTML = newVideo.innerHTML;
          modalVideo.load();
        }

        if (modalPlayBtn) {
          modalPlayBtn.style.display = 'flex';
        }

        itemBox.style.display = 'none';
        videoBox.style.display = 'flex';

        openModal();
      });
    }

    /* ======================
     MODAL VIDEO CONTROL
  ====================== */

    if (modalPlayBtn && modalVideo) {
      modalPlayBtn.addEventListener('click', () => {
        modalVideo.play();
      });

      modalVideo.addEventListener('play', () => {
        modalPlayBtn.style.display = 'none';
      });

      modalVideo.addEventListener('pause', () => {
        modalPlayBtn.style.display = 'flex';
      });

      modalVideo.addEventListener('ended', () => {
        modalPlayBtn.style.display = 'flex';
      });
    }

    /* ======================
     MODAL CONTROL
  ====================== */

    function openModal() {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';

      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
        modalVideo.innerHTML = '';
      }
    }

    overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const modal = document.querySelector('[data-testimonial-modal]');
    if (!modal) return;

    const titleEl = modal.querySelector('.tm-title');
    const textEl = modal.querySelector('.tm-text');
    const nameEl = modal.querySelector('.tm-name');
    const roleEl = modal.querySelector('.tm-role');
    const photoEl = modal.querySelector('.tm-photo');

    const closeEls = modal.querySelectorAll('[data-tm-close]');

    function openModalFromCard(card) {
      const tTitle = card.querySelector('.t-title');
      const tFull = card.querySelector('.t-full');
      const tName = card.querySelector('.t-name');
      const tRole = card.querySelector('.t-role');
      const tPhoto = card.querySelector('.t-photo');

      titleEl.textContent = tTitle ? tTitle.textContent.trim() : '';
      textEl.innerHTML = tFull ? tFull.innerHTML : '';
      nameEl.textContent = tName ? tName.textContent.trim() : '';
      roleEl.textContent = tRole ? tRole.textContent.trim() : '';

      if (tPhoto && tPhoto.getAttribute('src')) {
        photoEl.style.display = '';
        photoEl.src = tPhoto.getAttribute('src');
        photoEl.alt = (tPhoto.getAttribute('alt') || '').trim();
      } else {
        photoEl.style.display = 'none';
        photoEl.removeAttribute('src');
        photoEl.alt = '';
      }

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tm-lock');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tm-lock');
    }

    // Delegación: click en cualquier testimonial-card
    document.addEventListener('click', function (e) {
      const card = e.target.closest('[data-testimonial-card]');
      if (!card) return;
      openModalFromCard(card);
    });

    // Enter/Space para accesibilidad
    document.addEventListener('keydown', function (e) {
      const active = document.activeElement;
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
        return;
      }

      if ((e.key === 'Enter' || e.key === ' ') && active && active.matches('[data-testimonial-card]')) {
        e.preventDefault();
        openModalFromCard(active);
      }
    });

    // Cerrar
    closeEls.forEach((btn) => btn.addEventListener('click', closeModal));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-learn"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.landing-learn .item');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const open = item.classList.contains('is-open');

        items.forEach((i) => i.classList.remove('is-open'));

        if (!open) item.classList.add('is-open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-sticky"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sticky = document.querySelector('.landing-sticky');
    const countdown = document.querySelector('.sticky-countdown');

    if (!sticky || !countdown) return;

    /* =========================
     CONFIG
  ========================= */

    const SHOW_AFTER_PX = 1500; // 👈 AJUSTÁ ESTO

    /* =========================
     ESTADO INICIAL
  ========================= */

    let isExpired = false;

    sticky.style.opacity = '0';
    sticky.style.pointerEvents = 'none';
    sticky.style.transform = 'translateY(100%)';

    /* =========================
     COUNTDOWN
  ========================= */

    const endDate = countdown.dataset.date;
    if (!endDate) return;

    const target = new Date(endDate.split('/').reverse().join('-')).getTime();

    const daysEl = countdown.querySelector('.days');
    const hoursEl = countdown.querySelector('.hours');
    const minEl = countdown.querySelector('.minutes');
    const secEl = countdown.querySelector('.seconds');

    let timer = null;

    function hideSticky() {
      sticky.style.opacity = '0';
      sticky.style.pointerEvents = 'none';
      sticky.style.transform = 'translateY(100%)';
    }

    function showSticky() {
      if (isExpired) return;

      sticky.style.opacity = '1';
      sticky.style.pointerEvents = 'all';
      sticky.style.transform = 'translateY(0)';
    }

    function updateCountdown() {
      const now = Date.now();
      const diff = target - now;

      /* 👉 Expirado */
      if (diff <= 0) {
        isExpired = true;
        hideSticky();
        if (timer) clearInterval(timer);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minEl.textContent = String(minutes).padStart(2, '0');
      secEl.textContent = String(seconds).padStart(2, '0');
    }

    /* =========================
     SCROLL CONTROL
  ========================= */

    function handleScroll() {
      if (isExpired) return;

      if (window.scrollY >= SHOW_AFTER_PX) {
        showSticky();
      } else {
        hideSticky();
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    /* =========================
     INIT
  ========================= */

    // Si ya venció al cargar
    if (target <= Date.now()) {
      isExpired = true;
      hideSticky();
      return;
    }

    updateCountdown();
    timer = setInterval(updateCountdown, 1000);

    handleScroll(); // Ejecuta una vez al cargar
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-syllabus"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.landing-syllabus .item');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Cerrar todos
        items.forEach((i) => i.classList.remove('is-open'));

        // Si NO estaba abierto, lo abrimos
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-teachers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('teacherModal');
    if (!modal) return;

    const overlay = modal.querySelector('.tm-overlay');
    const closeBtn = modal.querySelector('.tm-close');
    const content = modal.querySelector('.tm-content');

    document.querySelectorAll('.landing-teachers .item .icons').forEach((icon) => {
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const item = icon.closest('.item');
        const data = item.querySelector('.item-modal-data');

        if (!data) return;

        content.innerHTML = data.innerHTML;

        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      content.innerHTML = '';
    }

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
